import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
     viewBox="0 0 24 24"
    >
      <g id="Icon" fillRule="evenodd" clipRule="evenodd">
        <path
          id="Icon_2"
          fill={colorValue}
         d="M12.75 3C12.75 2.58579 12.4142 2.25 12 2.25C11.5858 2.25 11.25 2.58579 11.25 3V11.25H7.5C7.19665 11.25 6.92318 11.4327 6.80709 11.713C6.691 11.9932 6.75517 12.3158 6.96967 12.5303L11.4697 17.0303C11.7626 17.3232 12.2374 17.3232 12.5303 17.0303L17.0303 12.5303C17.2448 12.3158 17.309 11.9932 17.1929 11.713C17.0768 11.4327 16.8033 11.25 16.5 11.25H12.75V3ZM3.75 16.5C3.75 16.0858 3.41421 15.75 3 15.75C2.58579 15.75 2.25 16.0858 2.25 16.5V18.75C2.25 19.5456 2.56607 20.3087 3.12868 20.8713C3.69129 21.4339 4.45435 21.75 5.25 21.75H18.75C19.5456 21.75 20.3087 21.4339 20.8713 20.8713C21.4339 20.3087 21.75 19.5456 21.75 18.75V16.5C21.75 16.0858 21.4142 15.75 21 15.75C20.5858 15.75 20.25 16.0858 20.25 16.5V18.75C20.25 19.1478 20.092 19.5294 19.8107 19.8107C19.5294 20.092 19.1478 20.25 18.75 20.25H5.25C4.85218 20.25 4.47064 20.092 4.18934 19.8107C3.90804 19.5294 3.75 19.1478 3.75 18.75V16.5Z"
        />
      </g>
    </svg>
  );
};

